import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import Settings from "./Settings";
import Auth from "./Auth";
import Common from "./Common";
import franchisee from "./franchisee";
import dealer from "./dealer";
import adminRideSetting from "./AdminSrtting"
import franchiseeName from "./franchiseeName";
import dealerName from "./dealerName";


const reducers = combineReducers({
  routing: routerReducer,
  settings: Settings,
  auth: Auth,
  commonData: Common,
  franchisee: franchisee,
  dealer: dealer,
  adminRideSetting: adminRideSetting,
  franchiseeName: franchiseeName,
  dealerName: dealerName
});

export default reducers;
